import angular from 'angular';
import moment from 'moment';
import {Component, Module} from 'app/decorators';
import ActivityStore from 'app/stores/activity';

import tpl from './activity.html';

@Module({
    name: "app.directives.activity",
    modules: [ActivityStore],
})
@Component({
    selector: 'blnd-activity',
    bindings: {
        object: '<',
    },
    template: tpl,
})
export default class C {
    constructor(ActivityStore) {
        "ngInject";
        this.store = ActivityStore.getNew(this.object);
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/activity.js